export class BillingRuleToUserTypeEntity {
    id;
    billingRuleId;
    userTypeId;
    constructor(id, billingRuleId, userTypeId) {
      this.id = id;
      this.billingRuleId = billingRuleId;
      this.userTypeId = userTypeId;
    }
  };
  